import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { DTO_RESPONSE__auth_success } from '@shared/dto/+user/auth/_requests/response_auth_success';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { StateUser } from '../../state_user';

export function try_set_is_authorized(state: StateUser, response: DTO_RESPONSE__auth_success | DTO_RESPONSE__error) {
  if (response instanceof DTO_RESPONSE__auth_success) {
    state.auth_token = response.auth_token;
    state.user_role = response.user_role;
    state.user_id = response.user_id;
    state.user_full_name = response.user_full_name;
    state.user_url_relative_avatar = response.user_url_relative_avatar;
    state.user_email = response.user_email;

    state.google_email = response.google_email;
    state.microsoft_email = response.microsoft_email;
    state.github_email = response.github_email;
    state.facebook_email = response.facebook_email;
    state.discord_email = response.discord_email;

    state.is_password_set = response.is_password_set;

    state.user_number = response.user_number;
    state.is_authorized = true;

    service_socketio_client.is_connection_authorized = true;

    CONSTANTS__client.LOGGER_USER_ID = response.user_id;
  } else {
    state.auth_token = '';
    state.is_authorized = false;

    service_socketio_client.is_connection_authorized = false;

    CONSTANTS__client.LOGGER_USER_ID = '';
  }
}
